import { Currency } from '@/core/currency/interfaces';

const PLN: Currency = {
    name: 'Polish Zloty',
    demonym: 'Polish',
    majorSingle: 'Zloty',
    majorPlural: 'Zlotys',
    codeNumeric: '985',
    symbol: 'zł',
    symbolNative: 'zł',
    minorSingle: 'Grosz',
    minorPlural: 'Groszy',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PLN',
    delimiters: {
        thousands: ' ',
        decimal: ','
    }
};

export default PLN;
